// Module
var code = `<div>
    <form name="cardDetailAddForm" id="cardDetailAddForm" #cardDetailAddForm="ngForm">
        <div tid="cardDetailsLabel"
             class="HOA-flextable-component__subheader u-mT3 u-mB7 HOA-flex-component HOA-flex-component-row-wrap">
            Card Details
        </div>
        <div class="HOA-flextable-component HOA-flextable-component__form HOA-Has-Default-Switch">
            <div class="Field HOA-default-switch-complimentary-column HOA-sm-order-2 HOA-lg-order-1 u-pH4">
                <label for="nameOnCard" class="Field-label" tid="nameOnCardLabel">
                    Name as it appears on your card
                    <span class="asterisk-required">&nbsp;*</span>
                    <div style="float: right;"></div>
                </label>
                <input type="text"
                       name="nameOnCard"
                       id="nameOnCard"
                       required
                       class="Input Field is-invalid"
                       tid="nameOnCardInput"
                       #nameOnCard="ngModel"
                       [ngClass]="{'HOA-form-input-field-error': formErrors.nameOnCard}"
                       (blur)="onBlur(nameOnCard)"
                       [(ngModel)]="formValues.nameOnCard">
                <div *ngIf="formErrors.nameOnCard">
                    <span class="HOA-form-field-error" tid="nameOnCard-field-error">Please enter the name on the card.</span>
                </div>
            </div>
            <div class="HOA-sm-order-1 HOA-lg-order-2 HOA-card-flex-offset-child-right">
                <div *ngIf="showDefault" class="HOA-Toggle-Align">
                    <span class="Toggle-label">Make Default</span>
                    <input id="defaultPaymentMethod"
                           name="defaultPaymentMethod"
                           class="HOA-Toggle HOA-Round-Toggle"
                           type="checkbox"
                           #defaultPaymentMethod="ngModel"
                           [(ngModel)]="formValues.defaultPaymentMethod">
                    <label for="defaultPaymentMethod"></label>
                </div>
            </div>
        </div>
        <div class="HOA-card-flex-container">
            <div class="Field HOA-card-flex-offset-child-left">
                <app-card-number-host
                        [cardUrl]="cardUrl"
                        [height]="cardInputHeight"
                        [className]="'Field HOA-card-flex-offset-child-left'"
                        [tid]="'cardNumberHost'">
                </app-card-number-host>
            </div>
            <div class="HOA-card-sub-flex-container">
                <div class="HOA-card-flex-offset-child-right HOA-flextable-component__flex-grow"
                     style="width:50%">
                    <div class="Field ">
                        <label for="expirationDateMonth" class="Field-label" tid="expDateLabel">
                            Expiration Date
                            <span class="asterisk-required">&nbsp;*</span>
                        </label>
                        <app-month-year-selects
                                (modelChange)="monthYearModelChange(\$event)">
                        </app-month-year-selects>
                    </div>
                </div>
                <div class="Field HOA-card-flex-offset-child-right HOA-card-flex-offset-child-right--sm-grow HOA-card-sm-0-pL3">
                    <label for="securityCode" class="Field-label" tid="securityCodeLabel">Security Code<span class="asterisk-required">&nbsp;*</span>
                        <div style="float: right;">
                            <button tid="showSecurityCodeHelpButton"
                                    class="u-pB1 HOA-flex-center-info-button HOA-helper-icon-margin-bottom"
                                    type="button"
                                    (click)="showSecurityCodeHelp()">
                                <span style="display: none;">Open Security Code Help</span>
                                <span class="Icon Icon--24 u-iconBlue">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             width="24"
                                             height="24"
                                             viewBox="0 0 72 72">
                                            <title>Open Security Code</title>
                                            <path class="stroke_layer"
                                                  d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                  fill="none"
                                                  stroke="#838383"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="3.8">
                                            </path>
                                            <path class="fill_layer"
                                                  d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                  fill="#838383" stroke-width="3.8">
                                            </path>
                                            <path class="stroke_layer"
                                                  data-name="stroke_layer"
                                                  d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
                                                  fill="none"
                                                  stroke="#838383"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="3.8">
                                            </path>
                                        </svg>
                                    </span>
                            </button>
                        </div>
                    </label>
                    <input type="text"
                           name="securityCode"
                           id="securityCode"
                           required
                           class="Input"
                           tid="securityCodeInput"
                           #securityCode="ngModel"
                           [ngClass]="{'HOA-form-input-field-error': formErrors.securityCode}"
                           (blur)="onBlur(securityCode)"
                           [(ngModel)]="formValues.securityCode"
                           numbers-only
                           maxlength="4">
                    <div *ngIf="formErrors.securityCode">
                        <span class="HOA-form-field-error" tid="securityCode-field-error">Please enter a valid security code.</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="showNickName" class="Field">
            <label for="cardNickname" class="Field-label" tid="cardNicknameLabel">
                Card Nickname
                <span class="asterisk-required">&nbsp;*</span>
                <div style="float: right;"></div>
            </label>
            <input type="text"
                   name="cardNickname"
                   id="cardNickname"
                   required
                   class="Input"
                   tid="cardNicknameInput"
                   maxlength="50"
                   #cardNickname="ngModel"
                   [ngClass]="{'HOA-form-input-field-error': formErrors.nickName}"
                   (blur)="onBlur(cardNickname)"
                   [(ngModel)]="formValues.nickName">
            <div *ngIf="formErrors.nickName">
                    <span class="HOA-form-field-error"
                          tid="cardNickname-field-error">Please provide card nickname.
                    </span>
            </div>
        </div>
    </form>
</div>`;
// Exports
module.exports = code;